import { LI, UL } from "../../../../../AbstractElements";

const CommonSquare = () => {
  return (
    <UL className="square-group simple-list">
      <LI className="square-1 warning" />
      <li className="square-1 primary" />
      <li className="square-2 warning1" />
      <li className="square-3 danger" />
      <li className="square-4 light" />
      <li className="square-5 warning" />
      <li className="square-6 success" />
      <li className="square-7 success" />
    </UL>
  );
};

export default CommonSquare;
